<template>
	<div>
	    <!--导航栏 start-->
	    <van-nav-bar
	            title="扫码点餐"
	            left-text="返回"
	            @click-left="onClickLeft"
	            left-arrow
	            fixed
	    />
	    <!--导航栏 end-->
	    <!--内容 start-->
	    <div style="margin-top: 1.5rem">
	        <van-cell title="菜品分类" is-link @click="food_class"/>
	        <van-cell title="菜品" is-link @click="food"/>
	    </div>
	    <!--内容 end-->
	</div>
</template>

<script>
	export default {
	    name: "CodeOrder", //扫码点餐
	    methods: {
	        // 左侧返回
	        onClickLeft() {
	            this.$router.push("/StoreHomepage");
	        },
	        // 菜品分类
	        food_class() {
	            // 跳转至菜品分类
	            this.$router.push("/FoodClassList");
	        },
	        // 菜品
	        food() {
	            // 跳转至菜品
	            this.$router.push("/FoodList");
	        },
	        
	    },
	}
</script>

<style>
</style>
